import * as angular from 'angular';
import parsePhoneNumber, {CountryCode} from 'libphonenumber-js'


export default angular.module('filters.tel', [])
    .filter('tel', function tel() {
        return function (input: string, countryCode: CountryCode) {
            if (!input) return '';
            const phoneNumber = parsePhoneNumber(input, countryCode || 'US');
            if(phoneNumber) {
                return phoneNumber.formatInternational();
            } else {
                return input;
            }
        };
    })
    .name;
